import './App.css';
import { Routes, Route } from "react-router-dom"
import Create from "./components/Create"
import Read from "./components/Read"
import Update from "./components/Update"
import Navbar from './components/Navbar';

function App() {
  return (
    <> 
    <Navbar/>
     <Routes>
        <Route path="/" element={ <Create/> } />
        <Route path="/all" element={ <Read/> } />
        <Route path="/:id" element={ <Update/> } />
      </Routes>
    </>
  );
}

export default App;
